// extracted by mini-css-extract-plugin
export default {"remarkContainer":"styles_remarkContainer__VCgaA","title":"styles_title__oYkOU","remark":"styles_remark__hjab2","close":"styles_close__-71wd"};